module.exports = __webpack_public_path__ + "img/logo2mix-1.e74629e2.jpg";